import {madnes_loader_completed} from "../framework/src/engine/madnes/madnes_loader";
import {
    big_win,
    mega_win, picture_convert,
    round_running,
    server_config, server_result, states,
    super_win,
    wi
} from "../framework/src/engine/madnes/madnes_variables";
import {get_orig_texture_name} from "./ps_core";
import {array_shuffle, get_random_int} from "./helpers";
import {
    madnes_anim_add,
    madnes_anim_add_oncomplete_once,
    madnes_anim_play, madnes_anim_stop, madnes_show_money, madnes_stop_coin
} from "../framework/src/engine/madnes/madnes_anims";
import {
    madnes_get_alpha,
    madnes_get_cstm_val, madnes_get_pos_x, madnes_get_pos_y, madnes_set_alpha, madnes_set_pos,
    madnes_set_pos_y, madnes_set_texture,
    madnes_set_visible,
    madnes_sprite_get_frame_name
} from "../framework/src/engine/madnes/madnes_object";
import {cylinder_pos, icons} from "./ps_config";
import {madnes_tween_func, madnes_tween_stop, madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {bet, madnes_get_atomic_bet, madnes_money_to_coin} from "../framework/src/engine/madnes/madnes";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {
    madnes_audio_fade_to,
    madnes_audio_loop,
    madnes_audio_play,
    madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";
import {madnes_add_to_render, madnes_move_to, madnes_rem_from_render} from "../framework/src/engine/madnes/madnes_render";
import {AnimSineBouncingY} from "./ps_extanims";
import {BigWinCounter} from "./BigWinCounter";
import {STATES} from "../framework/src/states/states";

export function change_multiplier(multip)
{
    return new Promise(function (res) {

        if(madnes_get_cstm_val("multiplier_group")['hided'] || madnes_get_cstm_val("multiplier_group")['multi'] == multip) {
            res();
            return;
        }

        hide_multiplier().then(function() {
            set_multiplier(multip);
            return show_multiplier();
        }).then(res);

    });
}

export function change_bar(type)
{
    return new Promise(function(res) {

        var waitFor = [];

        switch(type) {

            case "multi":

                waitFor.push(hide_logo());
                waitFor.push(hide_freespins());

                Promise.all(waitFor).then(function() {
                    show_multiplier();
                }).then(res);

                break;

            case "logo":

                waitFor.push(hide_freespins());
                waitFor.push(hide_multiplier());

                Promise.all(waitFor).then(function() {
                    show_logo();
                }).then(res);;

                break;

            case "fs":

                waitFor.push(hide_logo());
                waitFor.push(hide_multiplier());

                Promise.all(waitFor).then(function() {
                    show_freespins();
                }).then(res);;

                break;

            case "none":
            default:

                waitFor.push(hide_logo());
                waitFor.push(hide_multiplier());
                waitFor.push(hide_freespins());

                res();
                break;
        }

        waitFor = [];
    });
}

function hide_logo()
{
    return new Promise(function(res) {

        if(madnes_get_cstm_val("logo_reels")['hided']) {
            res();
            return;
        }

        madnes_tween_to("logo_reels", { 'y': -85 }, {
            'duration': 240,
            'easing': madnes_tween_func("back_in"),
            'callback': function() {
                madnes_get_cstm_val("logo_reels")['hided'] = true;
                res();
            }
        });
    });
}

function show_logo()
{
    return new Promise(function(res) {

        if(!madnes_get_cstm_val("logo_reels")['hided']) {
            res();
            return;
        }

        madnes_tween_to("logo_reels", { 'y': -10 }, {
            'duration': 240,
            'easing': madnes_tween_func("back_out"),
            'callback': function() {
                madnes_get_cstm_val("logo_reels")['hided'] = false;
                res();
            }
        });
    });
}

function hide_multiplier()
{
    return new Promise(function(res) {

        if(madnes_get_cstm_val("multiplier_group")['hided']) {
            res();
            return;
        }

        madnes_tween_to("multiplier_group", { 'y': -100 }, {
            'duration': 240,
            //'easing': madnes_tween_func(),
            'callback': function() {
                madnes_get_cstm_val("multiplier_group")['hided'] = true;
                madnes_set_pos_y("multiplier_group", -9999);
                madnes_set_visible("multiplier_group", false);
                res();
            }
        });

    });
}

function show_multiplier()
{
    return new Promise(function(res) {

        if(!madnes_get_cstm_val("multiplier_group")['hided']) {
            res();
            return;
        }

        madnes_set_pos_y("multiplier_group", -100);
        madnes_set_visible("multiplier_group", true);

        madnes_tween_to("multiplier_group", { y: 0 }, {
            'duration': 240,
            //'easing': madnes_tween_func(),
            'callback': function() {
                madnes_get_cstm_val("multiplier_group")['hided'] = false;
                res();
            }
        });

    });

}

function hide_freespins()
{
    return new Promise(function(res) {

        if(madnes_get_cstm_val("fs_group")['hided']) {
            res();
            return;
        }

        madnes_tween_to("fs_group", { 'y': -100 }, {
            'duration': 200,
            //'easing': madnes_tween_func(),
            'callback': function() {
                madnes_get_cstm_val("fs_group")['hided'] = true;
                madnes_set_visible("fs_group", false);
                res();
            }
        });

    });
}

function show_freespins()
{
    return new Promise(function(res) {

        if(!madnes_get_cstm_val("fs_group")['hided']) {
            res();
            return;
        }

        madnes_set_pos_y("fs_group", -200);
        madnes_set_visible("fs_group", true);

        madnes_tween_to("fs_group", { y: 0 }, {
            'duration': 240,
            //'easing': madnes_tween_func(),
            'callback': function() {
                madnes_get_cstm_val("fs_group")['hided'] = false;
                res();
            }
        });
    });
}








var last_multiplier;

var slideInMultipPosY = 0;
var slideOutMultipPosY = -100;

var slideOutTimeMultip = 200;
var slideInTimeMultip = 300;

export function unset_multiplier()
{
    for(var i = 2; i <= 5; i++) {
        madnes_set_visible("multiplier_x" + i, false);
    }
}

export function set_multiplier(multi)
{
    unset_multiplier();
    madnes_set_visible("multiplier_x" + multi, true);
    madnes_get_cstm_val("multiplier_group")['multi'] = multi;
}

///bigwin
var bigwin_anim = null;

function show_big_win_table(callback, from_freespin)
{
    if(from_freespin) {
        set_bigwin_type("free_spins");
    }

    madnes_set_text("bigwin_text", "0");

    madnes_set_pos("bigwin_group", wi / 2, -200);
    madnes_set_visible("bigwin_group", true);

    //madnes_audio_play('misc_Rope_Right');

    madnes_move_to("bigwin_group", wi / 2, 310, 400, function () {
        bigwin_anim = new AnimSineBouncingY("bigwin_group", 24, 0.08);

        bigwin_anim.onPI = function() {
            bigwin_anim.onPI = function() {};
            bigwin_anim.setLen(16);

        }.bind(bigwin_anim);

        bigwin_anim.on2PI = function() {
            bigwin_anim.on2PI = function() {};
            bigwin_anim.setVelocity(0.05);;
            bigwin_anim.setLen(10);
        }.bind(bigwin_anim);

        bigwin_anim.run();

        if(typeof callback === 'function') {
            callback();
        }
    });
}

function set_bigwin_type(type) {
    madnes_set_visible("free_spins", false);
    madnes_set_pos("free_spins", -9999, -9999);

    madnes_set_visible("big_win", false);
    madnes_set_pos("big_win", -9999, -9999);

    madnes_set_visible("mega_win", false);
    madnes_set_pos("mega_win", -9999, -9999);

    madnes_set_visible("super_mega_win", false);
    madnes_set_pos("super_mega_win", -9999, -9999);

    if(type == "free_spins") {
        madnes_set_pos_y("bigwin_text", 68);
        madnes_set_pos("text_your_free_spins_win", 0, 135);
        madnes_set_visible("text_your_free_spins_win", true);
    } else {
        madnes_set_pos_y("bigwin_text", 90);
        madnes_set_pos("text_your_free_spins_win", -9999, -9999);
        madnes_set_visible("text_your_free_spins_win", false);
    }

    madnes_set_visible(type, true);
    madnes_set_pos(type, 0, 0);
}

function hide_bigwin_table(callback)
{
    if(bigwin_anim != null) {
        bigwin_anim.stop();
    }

    madnes_move_to("bigwin_group", wi / 2, 330, 220, function () {
        madnes_move_to("bigwin_group", wi / 2, -200, 400, function () {
            madnes_set_visible("bigwin_group", false);
            madnes_set_pos("bigwin_group", -9999, -9999);
            bigwin_anim = null;

            if(typeof callback === 'function') {
                callback();
            }
        });
    });
}

/**
 * @param {number} won
 * @param {boolean=} from_freespin
 * @returns {Promise}
 */
export function money_add_big_win_anim(won, from_freespin)
{
    states.setState(STATES.BONUS_WIN);

    if(!from_freespin) {
        madnes_audio_fade_to("BACKGROUND", server_config["behavior"]["sound"]["background"]["background"] * 0.5, 1000);
    }

    return new Promise(function(res) {

        var audio_big_win_type = "big_win_snd";

        if(!from_freespin) {

            if(won > madnes_get_atomic_bet() * super_win) {
                audio_big_win_type = "super_mega_win_snd";
            } else if(won > madnes_get_atomic_bet() * mega_win) {
                audio_big_win_type = "mega_win_snd";
            }
        }

        setTimeout(madnes_audio_play.bind(this, audio_big_win_type), 600);

        if(from_freespin) {
            set_bigwin_type("free_spins");
        } else {
            set_bigwin_type("big_win");
        }

        show_big_win_table(function() {
            setTimeout(res, 150);
        }, from_freespin);

    }).then(function() {

        return new Promise(function(res) {

            (!from_freespin) && set_bigwin_type("big_win");


            //console.log(madnes_money_to_coin(won), bet, [big_win, mega_win, super_win]);

            var bigWinCounter = new BigWinCounter(madnes_money_to_coin(won), bet, [big_win, mega_win, super_win]);

            /*bigWinCounter.onBigWin(function() {
                //(!from_freespin) && set_bigwin_type("big_win");
            });*/

            bigWinCounter.onMegaWin(function() {
                (!from_freespin) && set_bigwin_type("mega_win");
            });

            bigWinCounter.onSuperWin(function() {
                (!from_freespin) && set_bigwin_type("super_mega_win");
            });

            bigWinCounter.onUpdate(function(val) {
                madnes_set_text("bigwin_text", Math.round(val));
            });

            bigWinCounter.run().then(res);

            madnes_audio_loop('remittance_A');

        });
    }).then(function() {

        return new Promise(function(res) {

            madnes_audio_stop('remittance_A');
            madnes_audio_play("remittance_B");

            madnes_stop_coin();

            setTimeout(function() {
                res();
            }, 2500);

        });

    }).then(function() {

        return new Promise(function(res) {
            hide_bigwin_table(res);
        });

    }).then(function() {

        madnes_audio_fade_to("BACKGROUND", server_config["behavior"]["sound"]["background"]["background"], 500);

    });
}

//anim standing

var stand_anim_count = 2;
var stand_symbols = {};
var stand_symbols_queue = [];
var stand_anim_stopped = true;
var stand_timeouts = [];

export function start_standing_symbols()
{
    //hide_all_stand_symbols();

    if(round_running || !madnes_loader_completed('stand_anim')) {
        return false;
    }


    stand_symbols = get_standing_symbols();
    stand_symbols_queue = array_shuffle(init_symbol_queue(stand_symbols));

    if (Object.keys(stand_symbols).length <= 1 || stand_symbols_queue.length <= 1) {
        console.warn(
            "standing anim error:",
            stand_symbols, stand_symbols_queue
        )
        return false
    }

    if (stand_anim_stopped) {
        stand_anim_stopped = false;

        for(var i = 1; i <= stand_anim_count; i++)
        {
            process_standing_anim(stand_symbols_queue, stand_symbols);
        }
    }
}

export function end_standing_symbols()
{
    stand_symbols_queue = [];

    for(var symbol in stand_symbols) {
        for(var i = 0; i < stand_symbols[symbol].length; i++) {
            var x = stand_symbols[symbol][i]['x'];
            var y = stand_symbols[symbol][i]['y'];

            var origSpriteName = "reels_bufer_" + x + "_S" + y;
            var standSpriteName = "reels_bufer_" + x + "_STND" + y;

            madnes_anim_stop(standSpriteName);
            madnes_set_texture(standSpriteName, null);
            madnes_set_visible(standSpriteName, false);

            madnes_set_visible(origSpriteName, true);
        }
    }

    for(var i = 0; i < stand_timeouts.length; i++)
    {
        if(typeof stand_timeouts[i] !== 'undefined')
        {
            clearTimeout(stand_timeouts[i]);
        }
    }

    stand_timeouts = [];

    stand_anim_stopped = true;
}

function process_standing_anim(queue, standSymbols)
{
    var symbol = get_from_queue(queue);

    if(!symbol) {
        return;
    }

    stand_anim_play(symbol, standSymbols).then(function() {
        add_to_queue(symbol, queue);

        process_standing_anim(queue, standSymbols);
    });
}

function stand_anim_play(symbol, standSymbols)
{
    return new Promise(function(resolve) {

        var anims = [];

        for(var i in standSymbols[symbol]) {

            var anim = new Promise(function(res) {

                var x = standSymbols[symbol][i].x;
                var y = standSymbols[symbol][i].y;

                var origSpriteName = "reels_bufer_" + x + "_S" + y;
                var standSpriteName = "reels_bufer_" + x + "_STND" + y;

                var origX = madnes_get_pos_x(origSpriteName);
                var origY = madnes_get_pos_y(origSpriteName);


                (function(origSpriteName, standSpriteName, symbol, origX, origY) {
                    var timeout = setTimeout(function() {

                        if(stand_anim_stopped)
                        {
                            madnes_set_pos(standSpriteName, -9999, -9999);
                            return;
                        }
                        madnes_set_texture(standSpriteName, symbol + "_standing_json");
                        madnes_anim_add(standSpriteName, "stand", icons[symbol]['stand']);

                        madnes_anim_add_oncomplete_once(standSpriteName, function() {
                            madnes_set_texture(standSpriteName, null);
                            madnes_set_visible(standSpriteName, false);
                            madnes_set_visible(origSpriteName, true);

                            var idx = stand_timeouts.indexOf(timeout);
                            stand_timeouts.splice(idx, 1);

                            res();
                        });

                        madnes_set_pos(standSpriteName, origX, origY);

                        madnes_set_visible(origSpriteName, false);
                        madnes_set_visible(standSpriteName, true);

                        madnes_anim_play(standSpriteName, "stand", 25);

                    }, get_random_int(500, 2000));

                    stand_timeouts.push(timeout);

                }(origSpriteName, standSpriteName, symbol, origX, origY));
            });

            anims.push(anim);
        }

        Promise.all(anims).then(resolve);
    });
}


function init_symbol_queue(standSymbols)
{
    var queue = [];

    for(var symbolName in standSymbols) {
        queue.push(symbolName);
    }

    return queue;
}


function get_standing_symbols()
{
    // take reelMatrix directly from server result, or init result if not defined
    let reelMatrix;
    if (server_result && server_result.result && server_result.result.reelMatrix) {
        let len = server_result.result.reelMatrix.length-1
        if (server_result.result.reelMatrix[len] ) {
            reelMatrix = server_result.result.reelMatrix[len]
        } else {
            reelMatrix = server_result.result.reelMatrix[0]
        }
    } else if (server_config && server_config.matrix && server_config.matrix.reelMatrix ) {
        reelMatrix = server_config.matrix.reelMatrix
    }
    var standSymbols = {};

    // take symbol name directly from picture_convert by reelMatrix index
    for (let x = 0; x < reelMatrix.length; x++) {
        for (let y = 0; y < reelMatrix[x].length; y++) {
            let key = picture_convert[reelMatrix[x][y]]
            if(!standSymbols[key])  standSymbols[key] = []
            standSymbols[key].push({
                'x': x,
                'y': 2 - y
            });
        }
    }
    return standSymbols;
}

function get_from_queue(queue)
{
    return queue.shift();
}

/*function get_random_from_queue(queue)
{
	return queue.splice(Math.floor(Math.random() * queue.length), 1);
}*/

function add_to_queue(item, queue)
{
    queue.push(item);
}

//end of anim standing

var fadingIn = [];

/**
 * @param {number} i
 * @param {string} type
 * @param {number=} duration
 * @returns {Promise}
 */
function fadein_reel_bonus(i, type, duration) {

    return new Promise(function(res) {

        var reelName = "reel_" + type + "_" + i;
        var dur = typeof duration !== 'undefined' ? duration : 180;

        madnes_set_visible(reelName, true);
        madnes_set_alpha(reelName, 0.001);
        madnes_set_pos(reelName, 69 + (228 * (i - 1)), 0);

        (function(reelName, i) {
            fadingIn[i] = madnes_tween_to(reelName, { 'alpha': 1 }, {
                'duration': dur,
                'callback': function() {
                    fadingIn[i] = null;
                    delete fadingIn[i];
                    res();
                }
            });
        } (reelName, i));
    });
}

export function fadeout_reel_bonus(i, type)
{
    var reelName = "reel_" + type + "_" + i;

    if(fadingIn[i]) {
        madnes_tween_stop(fadingIn[i]);
        fadingIn[i] = null;
        delete fadingIn[i];
    }

    if(madnes_get_alpha(reelName) === 0) {
        madnes_set_visible(reelName, false);
        return false;
    }

    (function(reelName) {
        madnes_tween_to(reelName, { 'alpha': 0 }, {
            'duration': 200,
            'callback': function() {
                //madnes_set_pos(reelName, -9999, -9999);
                madnes_set_alpha(reelName, 0);
                madnes_set_visible(reelName, false);
            }
        });
    } (reelName));
}

var reel_scatter_bonus_visible = false;
var reel_mystery_bonus_visible = false;

export function fadein_reel_bonus_from(reel, type)
{
    for(var i = reel + 1; i <= cylinder_pos.length; i++) {
        fadein_reel_bonus(i, type, 100);
    }
}

export function fadein_all_reel_bonus(type)
{
    return new Promise(function(res) {

        var anims = [];

        for(var i = 0; i <= cylinder_pos.length + 1; i++) {
            anims.push(fadein_reel_bonus(i, type));
        }

        Promise.all(anims).then(res);
    });
}

export function fadeout_all_reel_bonus(type)  {
    for(let i = 0; i <= cylinder_pos.length + 1; i++) {
        fadeout_reel_bonus(i, type);
    }
}

export function anims_money_add_win_anim(won)
{
    return new Promise(function (res) {

        madnes_audio_play("loop_win_celebrate");
        madnes_show_money(madnes_money_to_coin(won), res);

    });
}

/**
 * @constructor
 * @returns {WinCounter}
 */
export function WinCounter() {

    this.stopped = false;

    this.stepCount = 0;
    this.startVal = 0;
    this.endVal = 0;

    /** @type {number} */
    this.value;

    this.duration = 0;
    /** @type {number} */
    this.startTime;

    /** @type {Function} */
    this.resolver;
    /** @type {Function} */
    this.renderer;

    this._onUpdate = function(v) {};
    this._onStop = function(v) {};
};

function _getMicrotime() {
    return window.performance ? window.performance.now() : new Date().getTime();
};

WinCounter.prototype._step = function() {

    this.stepCount++;

    if(this.stepCount === 1) {
        this.startTime = _getMicrotime();
    }

    var elapsed = _getMicrotime() - this.startTime;
    var progress = elapsed / this.duration;

    progress = progress > 1 ? 1 : progress;

    if(this.duration === 0) {
        progress = 1;
    }

    if(this.startVal < this.endVal) {

        var diff = this.endVal - this.startVal;
        this.value = this.startVal + diff * progress;
        this._onUpdate(this.value);

    } else {

        var diff = this.startVal - this.endVal;
        this.value = this.startVal - diff * progress;
        this._onUpdate(this.value);

    }

    if(progress === 1) {
        this._end();
        if(this.resolver && !this.stopped) {
            this.resolver();
        }
    }
};

WinCounter.prototype._end = function() {
    madnes_rem_from_render(this.renderer);
};

WinCounter.prototype.run = function(from, to, totalTime) {

    if(this.stopped) {
        return new Promise(function(res) { res(); })
    }

    this.startVal = from;
    this.endVal = to;
    this.duration = totalTime;
    this.stepCount = 0;

    this.renderer = this._step.bind(this);

    this.value = 0;

    var _this = this;

    return new Promise(function(res) {
        _this.resolver = res;
        madnes_add_to_render(_this.renderer);
    });
};

WinCounter.prototype.onUpdate = function(func) {
    this._onUpdate = func;
};

WinCounter.prototype.onStop = function(func) {
    this._onStop = func;
};

WinCounter.prototype.stop = function(val) {
    this.stopped = true;
    this.resolver = null;
    this._end();
    this._onStop(val);
};

/**
 * @constructor
 * @returns {CounterAdd}
 */
export function CounterAdd() {
    this.freq = 30;
    this.incBy = 1;
    this.from = 0;
    this.to = 0;

    this.val = this.from;

    this._onComplete = function(v) {};
    this._onUpdate = function(v) {};

    /** @type {Function} */
    this.resolver;
}

CounterAdd.prototype.step = function() {

    if(this.from > this.to) {
        this.incBy = Math.abs(this.incBy) * -1;
    }

    this.val += this.incBy;

    this._onUpdate(this.val);

    if((this.from > this.to && this.val <= this.to) || (this.from < this.to && this.val >= this.to)) { //dec
        this.val = this.to;
        this._onComplete(this.val);
        this.resolver();

        return;
    }

    setTimeout(this.step.bind(this), this.freq);
};

/**
 * @param {number} from
 * @param {number} to
 * @param {number=} freq
 * @param {number=} incBy
 * @returns {Promise}
 */
CounterAdd.prototype.run = function(from, to, freq, incBy) {

    this.from = from;
    this.to = to;
    this.freq = freq ? freq : this.freq;
    this.incBy = incBy ? incBy : 1;
    this.val = this.from;

    var _this = this;

    return new Promise(function(res) {
        _this.resolver = res;

        if(_this.val == _this.to) {
            _this._onComplete(_this.val);
            res();
        } else {
            _this.step();
        }
    });
};

CounterAdd.prototype.onComplete = function(func) {
    this._onComplete = func;
};

CounterAdd.prototype.onUpdate = function(func) {
    this._onUpdate = func;
};